import { Divider, Table } from "@mantine/core"
import { IconHeading, IconSection } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"
import { Markdown } from "@/components/utils"
import { checkSurvey } from "@/types"
import { surveyInvite } from "@/utils"
import { scheduleSteps } from "."
import type { IStepProps } from "./types"
import { PreviewRow } from "./utils"

export function PreviewStep(props: IStepProps) {
  const { activity, form } = props
  const { t } = useTranslation()
  const { title, note } = form.values
  const defaultInvite = (form.values as any).defaultInvite
  const steps = scheduleSteps[activity.type] || scheduleSteps.other || []

  return (
    <>
      <Divider />
      <Table>
        <Table.Tbody>
          {checkSurvey(activity) && (
            <>
              <PreviewRow value={title}>
                <IconHeading />
                {t("Title")}
              </PreviewRow>
              <PreviewRow
                value={
                  <Markdown fz="sm" fw={500} ta="left">
                    {defaultInvite ? activity?.meta?.invite || t(surveyInvite) : note}
                  </Markdown>
                }
              >
                <IconSection />
                {t("Notification message")}
              </PreviewRow>
            </>
          )}

          {steps.map((Step) => Step.Preview && <Step.Preview key={Step.label} {...props} />)}
        </Table.Tbody>
      </Table>
    </>
  )
}

PreviewStep.label = "Confirmation"
